import React from "react";

export default function Circlebutton() {
    return (
        <div className="circle-button-container">
            <a href="#about" className="circle-button">
                v
            </a>
        </div>
    );
}
